import type CardTable from './cardTable';
import SvgManager from '../core/SvgManager';

interface FormatterT {
	className?: string;
	children: Array<JSX.Element>;
}

export type CardTableTemplate = JSX.Element | FormatterT | string;

const cellClassName = 'aras-card-table__cell';
const checkboxClassName = 'aras-checkbox';
export const cardTableFormatters: Record<
	string,
	(
		headId: string,
		rowId: string,
		value: unknown,
		control: CardTable
	) => CardTableTemplate
> = {
	boolean: (headId, rowId, value, control) => {
		const className = `${cellClassName}_shrunk`;
		const applyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
			const { checked: newValue } = event.target;
			const detail = {
				headId,
				rowId,
				newValue,
				oldValue: value
			};
			const changeEvent = new CustomEvent('applyChange', { detail });
			control.dispatchEvent(changeEvent);
		};
		const node = (
			<label className={checkboxClassName}>
				<input
					className={`${checkboxClassName}__input`}
					type="checkbox"
					checked={Boolean(value)}
					onChange={(event) => applyChange(event)}
				/>
				<span className={`${checkboxClassName}__check-button`} />
			</label>
		);

		return { className, children: [node] };
	},
	button: (headId, rowId, value) => {
		const text = String(value);
		const attributes = {
			className: 'aras-button aras-card__button',
			onclick: (event: MouseEvent) => event.stopPropagation(),
			title: text
		};
		const node = (
			<button {...attributes}>
				<span className="aras-button__text">{text}</span>
			</button>
		);

		return node;
	},
	icon: (headId, rowId, value) => {
		const className = `${cellClassName}_shrunk ${cellClassName}_with-icon`;
		const icon = SvgManager.createInfernoVNode(value, {
			cssClass: 'aras-card__icon'
		});
		const template = {
			className,
			children: icon ? [icon] : []
		};

		return template;
	},
	link: (headId, rowId, value) => {
		const node = (
			<span className="aras-link_a" role="link">
				{String(value)}
			</span>
		);

		return node;
	},
	text: (headId, rowId, value) => String(value ?? '')
};
